import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/cartService";
const store = {};
const mutations = {
    SET_MY_CARTS_AND_PUBLIC(state, posts) {
        state.myCartsAndPublicList = posts;
        state.myCartsAndPublicListIsLoading = false;
    }, 
    ADD_NEW_CART(state, posts) {
        state.myCartsAndPublicList.push(posts);
    },
    ADD_TO_CART(state, posts) {
        if (posts.isNew && posts.cart) {
            const curCart = state.myCartsAndPublicList.find(m => m.CrtName == posts.cart.CrtName && m.CrtId == 0);
            if (curCart != null) {
                curCart.CrtId = posts.cart.CrtId;
                curCart.CrtName = posts.cart.CrtName;
                curCart.CrtPublic = posts.cart.CrtPublic;
                curCart.IsOwner = posts.cart.IsOwner;
            }
        }
    }, 
    REMOVE_FROM_CART() {
    }, 
    EDIT_CART() { 
    }, 
    DELETE_CART(state, posts) {
        state.myCartsAndPublicList = state.myCartsAndPublicList.filter(m=>m.CrtId != posts.cart.CrtId);
    }, 
};
const state = {
    myCartsAndPublicListIsLoading: false,
    myCartsAndPublicList: [],
};
const getters = {};
const actions = {
    getMyCartsAndPublic({ commit }) {
        state.myCartsAndPublicListIsLoading = true;
        axios
            .get(baseUri + '/GetMyCartsAndPublic')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_MY_CARTS_AND_PUBLIC', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    createCart({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        axios.post(baseUri + '/CreateCart', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('ADD_NEW_CART', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    addToCart({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        axios.post(baseUri + '/AddToCart', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('ADD_TO_CART', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    removeFromCart({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        axios.post(baseUri + '/RemoveFromCart', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('REMOVE_FROM_CART', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    editCart({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        axios.post(baseUri + '/EditCart', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('EDIT_CART', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    deleteCart({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        axios.post(baseUri + '/DeleteCart', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('DELETE_CART', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}